export default "__VITE_ASSET__4170b799__"